export default __webpack_public_path__ + "static/media/icon-reversed-fleche-blanc.2a497a21.svg";